var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 17,
    viewBox: "0 0 27 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.28333 16.6667C6.13333 16.6667 6.91667 16.1833 7.28333 15.4333L9.65 10.7C9.88333 10.2333 10 9.73333 10 9.21667V1.66667C10 0.75 9.25 0 8.33333 0H1.66667C0.75 0 0 0.75 0 1.66667V8.33333C0 9.25 0.75 10 1.66667 10H5L3.28333 13.4333C2.53333 14.9167 3.61667 16.6667 5.28333 16.6667ZM21.95 16.6667C22.8 16.6667 23.5833 16.1833 23.95 15.4333L26.3167 10.7C26.55 10.2333 26.6667 9.73333 26.6667 9.21667V1.66667C26.6667 0.75 25.9167 0 25 0H18.3333C17.4167 0 16.6667 0.75 16.6667 1.66667V8.33333C16.6667 9.25 17.4167 10 18.3333 10H21.6667L19.95 13.4333C19.2 14.9167 20.2833 16.6667 21.95 16.6667Z",
    fill: "#82B7E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseQuotes);
export default __webpack_public_path__ + "static/media/close-quotes.aae8cbbaeedd510d58cc5b1b7fc3583b.svg";
export { ForwardRef as ReactComponent };